module.exports = __webpack_public_path__ + "img/undraw_add_post_64nu.51073e8a.svg";